import React from 'react'
import PropTypes from 'prop-types'
import {FooterTemplate} from "@trzyrybki/shared-ui/components/Footer";

const FooterPreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <FooterTemplate
        {...data}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

FooterPreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default FooterPreview
